import { render, staticRenderFns } from "./BookDownloadButton.vue?vue&type=template&id=5250839a&comments=true&"
import script from "./BookDownloadButton.vue?vue&type=script&lang=js&"
export * from "./BookDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports